import { useAppSelector } from 'hooks/reduxHooks'
import { getCanRedeemLuxPlusBenefits, getHasLuxPlusInAnyRegion, getIsEligibleLuxPlusFreePreview, getIsFreePreviewLuxPlusMember } from 'luxPlus/selectors/featureToggle'
import useQueryParams from 'hooks/useQueryParams'
import { LUXURY_PLUS, LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'

function getRegionalPathSegments(currentPath: string) {
  return currentPath.split('/').filter(Boolean)
}

/**
 * Determines whether to show the UI to sign up for LuxPlus+ free preview
 */
function useLuxPlusFreePreviewUtils(): {
  showFreePreviewSignup: boolean
  showFreePreviewCarouselSortOrder: boolean
  shouldAutoEnrolFreePreview: boolean
} {
  const freePreviewMember = useAppSelector(getIsFreePreviewLuxPlusMember)
  const freePreviewEligible = useAppSelector(getIsEligibleLuxPlusFreePreview)
  const canRedeemLuxPlusBenefits = useAppSelector(getCanRedeemLuxPlusBenefits)
  const hasPaidLuxPlusMembership = useAppSelector(getHasLuxPlusInAnyRegion)
  const currentPath = useAppSelector(state => state.router.location.pathname)
  const pathSegments = getRegionalPathSegments(currentPath)
  const isOnHomepage = pathSegments.length === 1
  const isOnLuxPlusLandingPage = pathSegments.length === 2 && pathSegments[1] === LUXURY_PLUS_PATHS.DEFAULT_LANDING_PAGE
  const isOnFlightsLandingPage = pathSegments.length === 2 && pathSegments[1] === 'flights'
  const isOnFlightsSearchResultsPage = pathSegments.length === 2 && pathSegments[1] === 'flights-search-results'
  const isOnFlightsSearchResultsMultiCityPage = pathSegments.length === 2 && pathSegments[1] === 'flights-search-results-multi-city'
  const isOnCheckoutFlightsPage = pathSegments.length === 3 && pathSegments[1] === 'checkout' && (pathSegments[2] === 'departing' || pathSegments[2] === 'returning')
  const queryParams = useQueryParams()
  const isFreePreviewParams = queryParams.get(LUXURY_PLUS.FREE_PREVIEW_QUERY_PARAM) === 'true'
  const canJoinFreePreview = !freePreviewMember && !canRedeemLuxPlusBenefits && !hasPaidLuxPlusMembership
  const showFreePreviewCarouselSortOrder = (isFreePreviewParams || freePreviewEligible || freePreviewMember) && !canRedeemLuxPlusBenefits && !hasPaidLuxPlusMembership
  const showFreePreviewSignup = (
    isFreePreviewParams ||
    freePreviewEligible ||
    isOnHomepage ||
    isOnLuxPlusLandingPage ||
    isOnFlightsLandingPage ||
    isOnFlightsSearchResultsPage ||
    isOnFlightsSearchResultsMultiCityPage ||
    isOnCheckoutFlightsPage
  ) && canJoinFreePreview
  const shouldAutoEnrolFreePreview = queryParams.get(LUXURY_PLUS.FREE_PREVIEW_AUTO_ENROLL_QUERY_PARAM) === 'true' && canJoinFreePreview

  return {
    showFreePreviewSignup,
    showFreePreviewCarouselSortOrder,
    shouldAutoEnrolFreePreview,
  }
}

export default useLuxPlusFreePreviewUtils
